import React, { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form'
import InputPlace from '../../common/InputPlace';

interface Iprops {
  onSubmit?: (str?: string) => void
}

function Search(props: Iprops) {
  const { onSubmit } = props
  let [value, setValue] = useState<any>()
  const { control } = useForm({ });
  let inpRef:any = null

  /* eslint-disable */
  const onChange = useCallback((e: any) => {
    let value = e.target.value
    inpRef = e.target
    setValue(value)
  }, [])

  const onClear = useCallback(() => {
    // console.log(inpRef)
    if (inpRef) {
      inpRef.value = ''
    }
    setValue('')
  }, [])

  const onPlaceSelected = useCallback((v: string) => {
    console.log('onPlaceSelected', v)
    setValue(v)
  }, [])


  const submit = useCallback(() => {
    onSubmit && onSubmit(value)
  }, [value, onSubmit])

  const onKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e && e.keyCode === 13) {
      onSubmit && onSubmit(value)
      return
    }
  },[value, onSubmit])

  return (
    <div className=' relative mt-[4.7vh]'>
        <InputPlace
          ref={inpRef}
          control={control}
          onChange={onChange}
          name="location"
          rules={{ required: "required" }}
          onKeyDown={onKeyDown}
          value={value}
          onPlaceSelected={onPlaceSelected}
        />
        <div
          className=' absolute flex items-center right-[4px] top-[5px] h-[40px] text-white text-sm leading-[40px] text-center'
        >
          {
            <div
              onClick={onClear}
              className='flex justify-center items-center self-start cursor-pointer w-[40px] h-[40px] font-[300] text-[30px] rotate-45 text-grey hover:text-black'
            >
              {
                value ? '+' : ''
              }
            </div>
          }
          <div
            onClick={submit}
            className=' cursor-pointer flex justify-center items-center self-end flex-shrink-0 bg-[#3FA1D9] w-[40px] h-[40px] rounded-[20px]'
          >
              <img
                  className=' w-[20px] h-[20px]'
                  src={require('../../../img/search_click.png')}
              />
          </div>
        </div>
    </div>
  );
}

export default Search;
